import { getBaseURL } from '../config/entorno';

export const ESTADOS = [
  { id: 'pendiente', label: 'Sin empezar' },
  { id: 'viendo', label: 'Viendo' },
  { id: 'vista', label: 'Terminadas' },
  { id: 'descartada', label: 'Descartadas' },
  { id: 'todas', label: 'Todas' },
];

export const TIPOS = [
  { id: 'pelicula', label: 'Película' },
  { id: 'serie', label: 'Serie' },
];

export const CATEGORIAS = [
  'Ficción',
  'No ficción',
  'Biografía',
  'Misterio',
  'Fantasía',
  'Ciencia ficción',
  'Histórica',
  'Romántica',
  'Terror',
  'Autoayuda',
  'Poesía',
  'Novela gráfica',
  'Aventuras',
  'Infantil',
  'Jóvenes adultos',
  'Clásicos',
  'Filosofía',
  'Antologías',
];

export function etiquetaTipo(tipo) {
  if (tipo === 'serie') return 'Serie';
  return 'Película';
}

export function etiquetaEstado(estado) {
  const map = {
    pendiente: 'Sin empezar',
    viendo: 'Viendo',
    vista: 'Terminada',
    descartada: 'Descartada',
  };
  return map[estado] || estado;
}

export function formatFa(valor) {
  if (valor == null || valor === '') return '';
  const n = Number(valor);
  if (!Number.isFinite(n)) return '';
  return n.toFixed(1).replace('.', ',');
}

export function formatEstrellas(valor) {
  const n = parseInt(valor, 10);
  if (!Number.isFinite(n) || n < 1) return 'Sin puntuar aún';
  return '⭐'.repeat(Math.min(5, n));
}

export function formatFechaHora(iso) {
  if (!iso) return '';
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return String(iso).slice(0, 16).replace('T', ' ');
  return d.toLocaleString('es-ES', {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
  });
}

export function urlPoster(posterUrl) {
  const raw = String(posterUrl || '').trim();
  if (!raw) return '';
  if (/^https?:\/\//i.test(raw)) return raw;
  const path = raw.startsWith('/') ? raw : `/${raw}`;
  const base = getBaseURL();
  if (base) return `${base}${path}`;
  return path;
}
